<div class="tt-c-answer-form">  
  <label :for="fieldId" class="tt-u-clip-hide" v-html="label"></label>
  <tt-textarea 
      :id="fieldId" 
      name="tt-c-answer-form-field" 
      class="tt-c-answer-form__textarea"
      ref="textArea"
      v-model="text"
      :focusOnMount="true"
      describedbyId="tt-c-answer-form-hint"
      :maxCharacters="maxCharacters"
      :errorText="errorMsg"
      :characterThreshold="200"      
      :hintText="$msg('answerReplyForm.instruction')"
  ></tt-textarea>
  <tt-multi-items v-if="showMultiItems" :multiItems="multiItems" :promptText="multiItemsPromptText" :sku="parent.catItem.sku" @addItems="addMultiItems" @removeItem="removeMultiItem"></tt-multi-items>
  <div class="tt-c-answer-form__action-buttons tt-o-button-group">
    <div v-show="isSubmitting" class="tt-o-spinner tt-o-spinner--submit"></div>
    <tt-button v-show="!isSubmitting" class="tt-c-answer-form__submit" @click="submitAnswerReply" v-html="$msg('answerReplyForm.submit')"></tt-button>
    <tt-button v-show="!isSubmitting && !hideCancel" type="secondary" class="tt-c-answer-form__cancel" @click="cancel" v-html="$msg('answerReplyForm.cancel')"></tt-button>
  </div>
</div>
